// plugins/v-instance.client.ts
import { defineNuxtPlugin } from '#app'
import vInstance from '~/directives/v-instance'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('instance', vInstance)
})
